// Create H7 to H12 headers
const headersToCreate = [7, 12];
const headers = {};

for(let i = headersToCreate[0]; i <= headersToCreate[1]; i++) {
  headers[`h${i}`] = {
    render: function (createElement) {
      return createElement(
        'div', {
          class: `h${i}`,
        }, this.$slots.default // array of children
      )
    },
  }
};

export default headers;
